
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/add-background",
      function () {
        return require("private-next-pages/add-background.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/add-background"])
      });
    }
  